import { observable, computed, action, runInAction } from 'mobx'
import api from '../api'

class Auth {
  @observable user
  @observable loaded = false

  @computed get loggedIn() {
    return !!this.user
  }

  constructor() {
    this.load()
  }

  @action
  load() {
    api.get('auth')
      .then(({data}) => {
        runInAction(() => {
          this.loaded = true
          this.user = data
        })
      })
      .catch(() => { this.loaded = true })
  }

  login(email, password) {
    return api.post('auth', { email, password }).then(
      ({data}) => { this.user = data }
    )
  }

  logout() {
    return api.delete('auth').then(
      () => { this.user = null }
    )
  }
}

export default Auth



// WEBPACK FOOTER //
// client/stores/auth.js